/* eslint-disable no-console */
import { makeAutoObservable } from 'mobx';

import { MessageBase, TerrainMessage, TextMessage } from '../models/Message';
import type { CampaignRootStore } from './CampaignRootStore';

class MessageStore {
  socket: WebSocket | null = null;

  receivedMessages: Record<string, MessageBase> = {}; // key: messageId

  receivedMessagesKeysOrder: string[] = []; // array of messageId of messages in receivedMessages

  messageToBeSent: MessageBase | null = null; // clientMessageId should be null

  messagesToBeSent: Record<string, MessageBase> = {}; // key: clientMessageId

  lastAssignedClientId = 0;

  isConnected = false;

  rootStore: CampaignRootStore;

  constructor(rootStore: CampaignRootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  updateSocket(socket: WebSocket | null): void {
    this.socket = socket;
  }

  updateIsConnected(isConnected: boolean): void {
    this.isConnected = isConnected;
  }

  addReceivedMessage(message: MessageBase | TextMessage | TerrainMessage): void {
    if (message.messageId) {
      this.receivedMessages = {
        ...this.receivedMessages,
        [message.messageId]: message
      };
      this.receivedMessagesKeysOrder.push(message.messageId);
    } else {
      console.error('Unable to add message to store - messageId is null.');
    }
  }

  getReceivedMessages(): MessageBase[] {
    return this.receivedMessagesKeysOrder.map((key) => this.receivedMessages[key]);
  }

  setMessageToBeSent(messageToBeSent: TextMessage | TerrainMessage | null): void {
    this.messageToBeSent = messageToBeSent;
  }

  addOrUpdateMessageToBeSent(messageToBeSent: MessageBase): void {
    if (messageToBeSent.clientMessageId) {
      this.messagesToBeSent = {
        ...this.messagesToBeSent,
        [messageToBeSent.clientMessageId]: messageToBeSent
      };
    }
  }

  removeMessageToBeSent(clientMessageId: string): void {
    if (this.messagesToBeSent[clientMessageId]) {
      delete this.messagesToBeSent[clientMessageId];
    }
  }

  assignNewClientId(): number {
    return ++this.lastAssignedClientId;
  }

  clearMessages(): void {
    this.receivedMessages = {};
    this.receivedMessagesKeysOrder = [];
    this.messageToBeSent = null;
    this.messagesToBeSent = {};
    this.lastAssignedClientId = 0;
  }
}

export default MessageStore;
